import { CarouselContainer } from './Slideshow.styled'
import { SlideshowDot, SlideshowArrows } from './components'

const RESPONSIVE_GRID = {
  default: {
    breakpoint: { max: 10000, min: 0 },
    items: 1,
  },
}

const Slideshow: React.FC = ({ children }) => (
  <CarouselContainer
    ssr={false}
    responsive={RESPONSIVE_GRID}
    arrows={false}
    showDots
    swipeable
    customDot={<SlideshowDot />}
    customButtonGroup={<SlideshowArrows />}
    dotListClass='slideshow-dots-list'
  >
    {children}
  </CarouselContainer>
)

export default Slideshow
